import find from "lodash/fp/find";
import filter from "lodash/fp/filter";
import isArray from "lodash/fp/isArray";
import forEach from "lodash/fp/forEach";
import constants from "../../core/constants";
import moment from "moment";

class FillParams {
  constructor($injector, Lists) {
    "ngInject";

    this.$injector = $injector;
    this.Lists = Lists;
  }

  get(params, filters) {
    const selectedGroup = [];
    const mergeSelected = (item) => {
      const getSelected = (selected) => selected[item.name];
      const selected = find(getSelected)(selectedGroup);

      if (selected) {
        item.selectedItem = selected[item.name];
      }
      return item;
    };

    for (const i in params) {
      if (isArray(params[i])) {
        const getAppliedFilter = (filter) => i === filter.name;
        const appliedFilter = find(getAppliedFilter)(filters);
        const getSelectedItems = (list) => params[i].indexOf(list.name) > -1;
        const selectedItems = filter(getSelectedItems)(
          this.Lists.all[appliedFilter.list]
        );
        const selected = {};

        selected[i] = selectedItems;
        selectedGroup.push(selected);
      } else if (params[i]) {
        const getAppliedFilter = (filter) => i === filter.name;
        const appliedFilter = find(getAppliedFilter)(filters);

        if (appliedFilter) {
          if (appliedFilter.resource && !appliedFilter.isList) {
            const selectedObject = this.$injector
              .get(appliedFilter.resource)
              .get(params[i]);
            const selected = {};
            selectedObject.$promise.then(() => {
              if (!selectedObject.name) {
                selectedObject.name =
                  selectedObject.route.name +
                  " " +
                  moment(selectedObject.date).format(constants.dateTimeFormat);
              }
            });
            selected[i] = selectedObject;
            selectedGroup.push(selected);
          } else if (appliedFilter.list) {
            const getSelectedItem = (list) => list.name === params[i];
            const selectedItem = find(getSelectedItem)(
              this.Lists.all[appliedFilter.list]
            );
            const selected = {};

            selected[i] = appliedFilter.multiple
              ? [selectedItem]
              : selectedItem;

            selectedGroup.push(selected);
          } else if (appliedFilter.date) {
            const selected = {};
            selected[i] = params[i];
            selectedGroup.push(selected);
          }
        }
      }
    }

    return forEach(mergeSelected)(filters);
  }
}

export default FillParams;



// WEBPACK FOOTER //
// ./src/services/fillParams/fillParams.service.js